import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Select, InputNumber, Spin, Divider, Typography } from 'antd';
import { connect } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { Utils } from '../../../utils/validators';
import { State, States } from 'sigt';
import axios from 'axios';
const server = process.env.REACT_APP_SERVER_URL;

const VehicleFields: React.FC<VehicleFieldsProps> = ({ form, onLoaded, auth, vhc, thm }) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isExisting, setIsExisting] = useState(false);
  const [tipo, setTipo] = useState<number>(-1);

  const [placa, setPlaca] = useState('');

  const { brands, types } = vhc;

  const carBodiesTypes = [
    'AMBULANCIA',
    'ARRASTRE',
    'ARTICULADO',
    'ATV',
    'AUTOBUS',
    'AUTOBUSETE',
    'BARANDA/HIERRO',
    'BATEA',
    'BLINDADO',
    'BOMBEADOR DE CONCRETO',
    'CABINA',
    'CAMION TRACTOR',
    'CARGADOR',
    'CASA RODANTE',
    'CASILLERO',
    'CAVA',
    'CAVA/GRANEL',
    'CESTA',
    'CESTA CANERA',
    'CHASIS',
    'CHASIS AUTOBUS',
    'CHASIS CABINA',
    'CHASIS LARGO',
    'CHASIS MINIBUS',
    'CHOPPER',
    'CHUTO',
    'CISTERNA',
    'COLECTIVO',
    'COMPACTADORA',
    'COMPACTO MPV',
    'CONVERTIBLE',
    'COSECHADORA',
    'COUPE',
    'COUPE CONVERTIBLE',
    'CROSS',
    'CROSSOVER',
    'CUSTON',
    'ENDURO',
    'ESPECIAL',
    'ESTACA/BARANDA',
    'ESTACA/ESTRUC/HIERRO',
    'ESTACAS',
    'EXCAVADORA',
    'FERRETERO',
    'FUNERARIO',
    'FURGON',
    'FURGON/CACHUCHA',
    'GABINETE',
    'GATO HIDRAULICO',
    'GEOFISICO',
    'GRANEL',
    'GRUA',
    'GRUA DE PLATAFORMA',
    'HATCH BACK',
    'JAULA',
    'JAULA GANADERA',
    'JAULA POLLERA',
    'LIMOUSINE',
    'LOW-BOY',
    'MEZCLADORA',
    'MINIBUS',
    'MINIVAN',
    'MONTA CARGA',
    'MOTOCICLETA',
    'MOTONETA',
    'NODRIZA',
    'PALA MECANICA',
    'PANEL',
    'PASEO',
    'PICK-UP',
    'PICK-UP C/CABINA',
    'PICK-UP D/CABINA',
    'PICK-UP/BARANDA',
    'PICK-UP/BARANDA/HIERRO',
    'PICK-UP/C CABINA',
    'PICK-UP/C FURGON',
    'PLATABANDA',
    'PLATAFORMA',
    'PLATAFORMA DESPLAZABLE',
    'PLATAFORMA FIJA',
    'PLATF/B HIDRAULICO',
    'PLATF/BARANDA',
    'PLATF/CACHUCHA',
    'PLATF/ESTACA',
    'PLATF/ESTRUC/HIERRO',
    'PLATF/G HIDRAULICO',
    'PORTA CONTENEDORES',
    'QUADS',
    'RACING',
    'RANCHERA',
    'RANCING',
    'RETRO EXCAVADORA',
    'RUSTICO',
    'SCOOTER',
    'SEDAN',
    'SEDAN CONVERTIBLE',
    'SILO',
    'SPORT WAGON',
    'SPORT WAGON CONVERTIBLE',
    'STATION WAGON',
    'SUPERVAN',
    'TANQUE',
    'TECHO DE LONA',
    'TECHO DURO',
    'TRACCION DE SANGRE',
    'TRACTOR',
    'TRANSPORTADOR',
    'TRAYLER',
    'TRIMOVIL',
    'UTILITARIO',
    'VACUUM',
    'VAN',
    'VOLTEO',
  ];

  const getVehicleByPlate = async (data, token) => {
    try {
      const response = await axios.get(`${server}/vehicles/getByPlate/${data.plate}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    setPlaca('');
    console.log('Reset placa');
    form.setFieldsValue({
      placa: undefined,
    });
    return () => {
      if (onLoaded) {
        onLoaded(null);
      }
    };
  }, []);

  useEffect(() => {
    if (placa && placa.length >= 6) {
      buscarVehiculo(placa);
    } else {
      setVisible(false);
      resetFields();
    }
  }, [placa]);

  const resetFields = () => {
    setIsExisting(false);
    setTipo(-1);

    form.setFieldsValue({
      marca: undefined,
      modelo: undefined,
      anio: undefined,
      color: undefined,
      tipoCarroceria: undefined,
      tipo: undefined,
      categoria: undefined,
      tipoCombustible: undefined,
      serialCarroceria: undefined,
    });

    if (onLoaded) onLoaded(null);
  };

  const buscarVehiculo = async (numPlaca: string) => {
    setLoading(true);
    setVisible(true);
    try {
      const response = await getVehicleByPlate({ plate: numPlaca }, auth.token);

      if (response.data) {
        const v = response.data;

        const vehicleTypeIdx = types.findIndex((t) => t.categorias.some((c) => c.id === v.categoria_id || c.id === v.categoria));

        setTipo(vehicleTypeIdx);
        setIsExisting(true);

        form.setFieldsValue({
          marca: v.marca,
          modelo: v.modelo,
          anio: v.anio,
          color: v.color,
          tipoCarroceria: v.tipoCarroceria,
          tipo: vehicleTypeIdx,
          categoria: v.categoria,
          tipoCombustible: v.tipoCombustible,
          serialCarroceria: v.serialCarroceria,
        });

        if (onLoaded) onLoaded(v.id);
      } else {
        resetFields();
      }
    } catch (error) {
      resetFields();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Col span={24}></Col>
      <Divider style={{ margin: 5, marginLeft: -5 }} orientation='left'>
        <Typography.Text strong style={{ marginLeft: 5 }}>
          Datos del Vehículo Infractor
        </Typography.Text>
      </Divider>

      <Col xl={8} xs={24}>
        <Form.Item
          label='Placa'
          name='placa'
          help={
            visible && !loading ? (
              isExisting ? (
                <span style={{ color: thm.primaryColor }}>Vehículo encontrado</span>
              ) : (
                <span>Vehículo no encontrado, ingrese los datos</span>
              )
            ) : null
          }
          normalize={Utils.normalize.toUpper}
          rules={[{ required: true, message: 'Debe ingresar la Placa' }]}
        >
          <Input placeholder='Placa' minLength={6} maxLength={7} onBlur={(e) => setPlaca(e.target.value)} onPressEnter={(e) => e.currentTarget.blur()}/>
        </Form.Item>
      </Col>

      {loading && (
        <Col span={24} style={{ textAlign: 'center', padding: '20px' }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} tip='Buscando vehículo...' />
        </Col>
      )}

      {!visible && <Col span={24}></Col>}

      {!loading && visible && (
        <>
          <Col xl={8} xs={24}>
            <Form.Item label='Marca' name='marca' rules={[{ required: true, message: 'Debe seleccionar marca del vehículo.' }]}>
              <Select
                showSearch
                open={isExisting ? false : undefined}
                style={{ cursor: isExisting ? 'default' : 'pointer' }}
                filterOption={(value, option) => (option?.title as string)?.includes(value.toUpperCase())}
                placeholder='Marca'
              >
                {brands?.map((b) => (
                  <Select.Option value={b.id} key={b.id} title={b.nombre?.toUpperCase()}>
                    {b.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item
              label='Modelo'
              name='modelo'
              rules={[{ required: true, message: 'Debe seleccionar modelo del vehículo.' }]}
            >
              <Input placeholder='Modelo' readOnly={isExisting} />
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item label='Año' name='anio' rules={[{ required: true, message: 'Debe ingresar año del vehículo.' }]}>
              <InputNumber style={{ width: '100%' }} max={9999} min={1800} placeholder='Año' readOnly={isExisting} />
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item label='Color' name='color' rules={[{ required: true, message: 'Debe ingresar color del vehículo.' }]}>
              <Input placeholder='Color' readOnly={isExisting} />
            </Form.Item>
          </Col>

          <Col xl={8} xs={24}>
            <Form.Item
              label='Tipo de Carrocería'
              name='tipoCarroceria'
              rules={[{ required: true, message: 'Debe ingresar el tipo de carrocería.' }]}
            >
              <Select
                placeholder='Tipo de Carrocería'
                open={isExisting ? false : undefined}
                style={{ cursor: isExisting ? 'default' : 'pointer' }}
              >
                {carBodiesTypes.map((ct) => (
                  <Select.Option key={ct} value={ct} title={ct}>
                    {ct}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xl={12} xs={24}>
            <Form.Item
              label='Tipo de Vehículo'
              name='tipo'
              rules={[{ required: true, message: 'Debe seleccionar el tipo de vehículo' }]}
            >
              <Select
                placeholder='Tipo de Vehículo'
                open={isExisting ? false : undefined}
                style={{ cursor: isExisting ? 'default' : 'pointer' }}
                onChange={(val: number) => {
                  setTipo(val);
                  form.setFieldsValue({ categoria: undefined });
                }}
              >
                {types.map((t, i) => (
                  <Select.Option value={i} key={t.id}>
                    {t.descripcion}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xl={12} xs={24}>
            <Form.Item label='Categoria' name='categoria' rules={[{ required: true, message: 'Debe seleccionar la categoria' }]}>
              <Select
                open={isExisting ? false : undefined}
                style={{ cursor: isExisting ? 'default' : 'pointer' }}
                placeholder='Categoria'
              >
                {types[tipo]?.categorias.map((c: any) => (
                  <Select.Option value={c.id} key={c.id}>
                    {c.descripcion}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xl={12} xs={24}>
            <Form.Item
              label='Tipo de Combustible'
              name='tipoCombustible'
              rules={[{ required: true, message: 'Debe ingresar el tipo del combustible' }]}
            >
              <Select
                placeholder='Combustible'
                open={isExisting ? false : undefined}
                style={{ cursor: isExisting ? 'default' : 'pointer' }}
              >
                <Select.Option value='GASOLINA' title='GASOLINA'>
                  GASOLINA
                </Select.Option>
                <Select.Option value='GASOIL' title='GASOIL'>
                  GASOIL
                </Select.Option>
                <Select.Option value='GAS' title='GAS'>
                  GAS
                </Select.Option>
                <Select.Option value='ELECTRICIDAD' title='ELECTRICIDAD'>
                  ELECTRICIDAD
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xl={12} xs={24}>
            <Form.Item
              label='Serial Carrocería'
              name='serialCarroceria'
              rules={[{ required: true, message: 'Debe ingresar el serial de la carroceria' }]}
            >
              <Input placeholder='Serial Carrocería' readOnly={isExisting} />
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
};

const mapStateToProps = ({ auth, vhc, thm }: State) => ({ auth, vhc, thm });

export default connect(mapStateToProps)(VehicleFields);

interface VehicleFieldsProps {
  form: any;
  onLoaded?: (id: number | null) => void;
  auth: States.Auth;
  vhc: States.Vehicles;
  thm: States.ThemeColors;
}
